export const BreakFlexDiv = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const SuccessMessage = styled.p`
  width: 270px;
  text-align: center;
  margin-top: 10px;
`;

export const SuccessGenerationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 130px;
  flex-direction: column !important;
`;

export const SuccessImage = styled.img`
  width: 160px;
  height: 166px;
`;

export const Separator = styled.div`
  border: 1px solid #ebebeb;
  margin-top: 10px;
  margin-bottom: 20px;
`;
